module.exports = __webpack_public_path__ + "fonts/SilkSerif-Medium.0410abf6e37f75af8132099986c6e5df.woff2";